import { EDITOR_HIDE_BUILDER_LOADER } from './constants';

export function hideBuilderLoader() {
  return {
    type: EDITOR_HIDE_BUILDER_LOADER,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_HIDE_BUILDER_LOADER:
      return {
        ...state,
        showBuilderCanvasLoader: false,
      };

    default:
      return state;
  }
}
